import DashboardComponents from 'motivate-dashboarding-components'
import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import axios from "axios";
import FBconfig from "./fb.config";
import 'firebase/firestore'
import VueFire from 'vuefire'
import 'motivate-framework/dist/css/motivate.css'
import Bounce from 'bounce.js'
import tinycolor from 'tinycolor2'
import patternomaly from 'patternomaly'

const firebase = require("firebase");
window.moment = require('moment')

Vue.prototype.$bounce = Bounce
Vue.config.performance = true
require('./filters/filters');
window._ = require('lodash')
window.tinycolor = tinycolor
window.pattern = patternomaly
var hash = window.location.hash.substr(1).split(',')

const DashboardHash = hash[0]
store.commit('setDashboardHash', DashboardHash)

const DATA_API = axios.create({
    baseURL: process.env.VUE_APP_DATA_API,
    timeout: 5000,
    headers: {
        'Motivate-dashboard-hash': DashboardHash, // THIS is the way to authenticate on new dashbaords
    },
});


// setup auth for firebase
if (process.env.NODE_ENV === 'production') {
    DATA_API.get('dashboard/' + DashboardHash).then(res => {
        firebase.initializeApp(FBconfig);
         firebase.auth().signInWithCustomToken(res.data.firebaseAuthToken).then(() => {
            Vue.prototype.$FB = firebase.firestore()
            Vue.use(VueFire)
            // registerComponentsFromApi(res.data.components)
            registerComponents()
            renderVue()
        }).catch(function (error) {
            var errorCode = error.code;
            var errorMessage = error.message;
        });

    })
}

if (process.env.NODE_ENV !== 'production') {

    DATA_API.get('dashboard/' + DashboardHash).then(res => {
        store.commit('setDashboardConfig', res.data)
        firebase.initializeApp(FBconfig);
        Vue.prototype.$FB = firebase.firestore()
        Vue.use(VueFire)
        firebase.auth().signInAnonymously().catch(function (error) {
            var errorCode = error.code;
            var errorMessage = error.message;
        });

        // registerComponentsFromApi(res.data.components)
        registerComponents().then(()=>{
            renderVue()
        }).catch(()=>{
            renderVue()
        })
        // renderVue()
    }).catch(()=>{
      renderVue()
    })

}

// old version, remove if not used anymore
function registerComponentsFromApi(components) {
    components.forEach((component) => {
        Vue.component(component.type, DashboardComponents[component.type])
    })
}

function registerComponents() {

    return new Promise( (resolve, reject) => {
        Vue.prototype.$FB.collection('dashboardConfigs').doc(DashboardHash).get().then((doc) => {
            store.commit('setDashboardConfig', doc.data().components)
            doc.data().components.forEach((componentConfig) => {
                Vue.component(componentConfig.type, DashboardComponents[componentConfig.type])
            })
            resolve()
        })

    })
}

function renderVue() {
    new Vue({
        router: router,
        store: store,
        render: h => h(App),
    }).$mount('#app')
}